import { RecordReporting } from './../../_models/mfa/RecordReporting';
import { AddRecordReporting } from './../../_models/mfa/AddRecordReporting';

import { EnviromentService } from './../enviroment.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { PaginatedResult } from 'app/_models/Pagination';
import { map } from 'rxjs/operators';

@Injectable()
export class RecordReportingService {
    baseUrl = '';

    constructor(private http: HttpClient, private enviromentService: EnviromentService) {
        this.baseUrl = enviromentService.getConfig().apiMfa;
     }

    add(add: AddRecordReporting): Observable<number> {
        return this.http.post<number>(this.baseUrl + 'RecordsAndReportings', add);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.baseUrl + 'RecordsAndReportings/' + id);
    }

    update(update: RecordReporting): Observable<number> {
        return this.http.put<number>(this.baseUrl + 'RecordsAndReportings/' + update.id, update);
    }

    get(id: number): Observable<RecordReporting> {
        return this.http.get<RecordReporting>(this.baseUrl + 'RecordsAndReportings/' + id);
    }

    getRecordReportings(page?, itemsPerPage?, RecordReportingParams?): Observable<PaginatedResult<RecordReporting[]>> {
        const paginatedResult: PaginatedResult<RecordReporting[]> = new PaginatedResult<RecordReporting[]>();
    
        let params = new HttpParams();
    
        if (page != null && itemsPerPage != null) {
          params = params.append('pageNumber', page);
          params = params.append('pageSize', itemsPerPage);
        }
    
    
        return this.http.get<RecordReporting[]>(this.baseUrl + 'RecordsAndReportings', { observe: 'response', params})
          .pipe(
            map(response => {
              paginatedResult.result = response.body;
              if (response.headers.get('Pagination') != null) {
                paginatedResult.pagination = JSON.parse(response.headers.get('Pagination'));
              }
              return paginatedResult;
            })
          );
      }


    getByMfaId(id: number): Observable<RecordReporting[]> {
        return this.http.get<RecordReporting[]>(this.baseUrl + 'MasterFranchiseAgreements/' + id + '/RecordsAndReportings/');
    }

}